import React  from 'react';
import { useAppDispatch, useAppSelector } from '../../../../store/hooks';
import { toggleSidebar } from "../../../../store/sessionSlice";

import ProfileMenu from "../ProfileMenu";
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined
} from '@ant-design/icons';
import { Layout } from 'antd';
import './style.scss';

const Header: React.FC = () => {
  const dispatch = useAppDispatch();
  const { collapsed } = useAppSelector(state => state.session);

  const toggle = () => {
    dispatch(toggleSidebar(!collapsed));
  };

  const FoldIcon = () => {
    if (collapsed) {
      return <MenuUnfoldOutlined className="collapsed-icon" onClick={toggle} />
    } else {
      return <MenuFoldOutlined className="collapsed-icon" onClick={toggle} />
    }
  };

  return (
    <Layout.Header className="v-header">
      <div className='v-header--left'>
        <FoldIcon />
      </div>

      <div className='v-header--right'>
        <ProfileMenu />
      </div>
    </Layout.Header>
  );
}

export default Header;
